import React from 'react';
import { Box } from '@mui/material';
import CardTela from '../CardTela/CardTela';
import useListaTelasHook from './useListaTelasHook';
import './styles.scss';

// A ferramenta pode devolver dezenas de telas, mas a resposta cita poucas.
// Mostrar tudo transformaria o cartao — que deveria ser o atalho — num segundo
// menu para o usuario varrer.
const MAXIMO_CARTOES = 6;

/**
 * Codigos de submenu citados no texto da resposta.
 *
 * Extrai os numeros do texto em vez de procurar cada codigo com includes():
 * "26" contem "6", entao um includes promoveria a tela 6 sempre que a 26 fosse
 * citada. Aqui a comparacao e entre numeros inteiros, sem casar por pedaco.
 */
const extrairCodigosCitados = texto => new Set((texto ?? '').match(/\d+/g) ?? []);

/**
 * Ordena as telas priorizando as que o modelo realmente citou no texto.
 *
 * O criterio e deterministico e nao depende de o modelo emitir sintaxe alguma.
 * Quando nada casa (resposta generica), preserva a ordem do backend.
 */
const priorizarCitadas = (telas, texto) => {
  const citados = extrairCodigosCitados(texto);

  if (citados.size === 0) {
    return telas;
  }

  const foiCitada = tela => citados.has(String(tela.cod_submenu));

  return [...telas.filter(foiCitada), ...telas.filter(tela => !foiCitada(tela))];
};

export default function ListaTelas({ telas, textoResposta, aoNavegar }) {
  const { abrirTela, abrindo } = useListaTelasHook({ aoNavegar });

  if (!telas?.length) {
    return null;
  }

  const visiveis = priorizarCitadas(telas, textoResposta).slice(0, MAXIMO_CARTOES);

  return (
    <Box className="chat-ia-lista-telas">
      {visiveis.map((tela, indice) => (
        <CardTela
          key={tela.cod_submenu}
          tela={tela}
          destacado={indice === 0}
          aoAbrir={abrirTela}
          abrindo={abrindo === tela.cod_submenu}
        />
      ))}
    </Box>
  );
}
